import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Home from "./screens/Home";
import AboutScreen from "./screens/AboutScreen";
import ProjectScreen from "./screens/ProjectScreen";
import theme from './theme/theme';

// PHOSAI - World-Class AI & Machine Translation
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutScreen />} />
          <Route path="/products" element={<ProjectScreen />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
